"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placement = void 0;
exports.Placement = Object.freeze({
    Top: 'top',
    Bottom: 'bottom',
    Left: 'left',
    Right: 'right',
    TopStart: 'top-start',
    TopEnd: 'top-end',
    BottomStart: 'bottom-start',
    BottomEnd: 'bottom-end',
    RightStart: 'right-start',
    RightEnd: 'right-end',
    LeftStart: 'left-start',
    LeftEnd: 'left-end',
    Auto: 'auto',
    AutoStart: 'auto-start',
    AutoEnd: 'auto-end',
});
//# sourceMappingURL=types.js.map